import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic, clientPublicService } from 'helper/axios'
let resError = ''

export const getResultBusiness = async ({ token }) => {
  try {
    return await clientPublic
      .get('businessunit?limit=100', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const addBusiness = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('businessunit', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const updateBusiness = async ({ params, token }) => {
  try {
    return await clientPublic
      .put(`businessunit/${params.id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const deleteBusiness = async ({ id, code, token }) => {
  try {
    return await clientPublic
      .delete(`businessunit/${id}?code=${code}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getResultBusinessV2 = async ({ token }) => {
  try {
    return await clientPublicService
      .get('/core/management/business-group', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getBusinessUnitList = async ({ token, page = 1, per_page = 10, code, name_th, name_en, status, order_by, order }) => {
  try {
    const params = { page, per_page }
    if (code) params.code = code
    if (name_th) params.name_th = name_th
    if (name_en) params.name_en = name_en
    if (status) params.status = status
    if (order_by) params.order_by = order_by
    if (order) params.order = order

    return await clientPublicService
      .get('core/management/sync-business-unit', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
